<template>
  <div v-if="!selecionouSegmento">
    <div class="antecipacao-container" v-for="pergunta in imposto" :key="pergunta.id_tributacao">
      <RadioButton
        :classe="'antecipacao'"
        :imposto="pergunta"
        :seleciona="seleciona"
        :loading="loading"
      />
      <Registro>
        <div v-if="pergunta.id_imposto != 100">
          <Descricao :titulo="'Segmento'" :descricao="pergunta.segmento" />
          <div class="separador" />

          <Cabecalho
            v-if="pergunta.atribuicao_responsabilidade"
            :titulo="'Atribuição de Responsabilidade'"
            :aliquota="pergunta.atribuicao_responsabilidade.toUpperCase()"
          />

          <div v-if="pergunta.atribuicao_responsabilidade" class="separador" />

          <Cabecalho
            :tipo="'icone'"
            :classe="'antecipacao'"
            :titulo="'Antecipação Com Encerramento'"
            :aliquota="pergunta.antecipacao"
          />
          <div class="separador" />

          <Ncm :ncm="pergunta.ncm" />
          <div v-if="pergunta.ncm" class="separador" />

          <Descricao :titulo="'Descrição'" :descricao="pergunta.descricao" />

          <div class="separador" />
          <BaseLegal :base_legal="pergunta.base_legal" />
        </div>
        <div v-else>
          <Inaplicabilidade
            :imposto="'Antecipação Tributária'"
            :texto="pergunta.texto_inaplicabilidade"
          />
        </div>
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="antecipacao-container">
      <EditButton :classe="'antecipacao'" :edita="edita" :loading="loading" />
      <Registro>
        <div v-if="segmentoSelecionado.id_imposto != 100">
          <Descricao :titulo="'Segmento'" :descricao="segmentoSelecionado.segmento" />
          <div class="separador" />

          <Cabecalho
            v-if="segmentoSelecionado.atribuicao_responsabilidade"
            :titulo="'Atribuição de Responsabilidade'"
            :aliquota="segmentoSelecionado.atribuicao_responsabilidade.toUpperCase()"
          />
          <div v-if="segmentoSelecionado.atribuicao_responsabilidade" class="separador" />

          <Cabecalho
            :tipo="'icone'"
            :classe="'antecipacao'"
            :titulo="'Antecipação Com Encerramento'"
            :aliquota="segmentoSelecionado.antecipacao"
          />
          <div class="separador" />

          <Ncm :ncm="segmentoSelecionado.ncm" />
          <div v-if="segmentoSelecionado.ncm" class="separador" />

          <Descricao :titulo="'Descrição'" :descricao="segmentoSelecionado.descricao" />

          <div class="separador" />
          <BaseLegal :base_legal="segmentoSelecionado.base_legal" />
        </div>
        <div v-else>
          <Inaplicabilidade
            :imposto="'Antecipação Tributária'"
            :texto="segmentoSelecionado.texto_inaplicabilidade"
          />
        </div>
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
export default {
  name: "PerguntasIcmsAntecipacao",

  props: {
    imposto: Object | Array,
    edita: Function,
    loading: Boolean,
    seleciona: Function,
    segmentoSelecionado: Object,
    selecionouSegmento: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Inaplicabilidade,
    Ncm,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.antecipacao-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.atribuicao-responsabilidade {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0;
}
</style>
